import { Box, Typography } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { WithTranslation, withTranslation } from "react-i18next";
import RAGStatus from "../../../pages/properties/PropertyListPage/model/RAGStatus";
import {
  TimePeriodFilter,
  subtitleForTimePeriod,
  timePeriodForRecentOnly,
} from "../../../pages/properties/PropertyListPage/model/TimePeriodFilter";
import RootState from "../../../redux/RootState";
import { DEFAULT_SPACING, LARGE_SPACING } from "../../theme/dimensions";
import { DashboardMetrics } from "../DashboardLayout/redux/DashboardState";
import RAGCard from "./components/RAGCard";

// Because the animation should run only once, we want this to
// be globally defined for every DashboardLayout.
// We do not want this to be different for each instance of DashboardLayout.
let hasAnimationRun = false;

interface ReduxStateProps {
  isGreenCardActive: boolean;
  isAmberCardActive: boolean;
  isRedCardActive: boolean;
  selectedTimePeriod: TimePeriodFilter;

  metrics: DashboardMetrics | undefined;
}

type Props = ReduxStateProps & WithTranslation;

class RAGCards extends React.Component<Props> {
  componentDidMount() {
    // This is run after the first render, turning off the animation
    // and making sure it's only once.
    hasAnimationRun = true;
  }

  render() {
    const timePeriodLabel = `${this.props.t("ragStatusCard.periodLabel")} ${subtitleForTimePeriod(
      this.props.selectedTimePeriod,
      this.props.t
    )}`;

    return (
      <Box display="flex" justifyContent="center" paddingX={DEFAULT_SPACING}>
        <Box position="relative" display="inline-block">
          <Box
            position="absolute"
            top={-12}
            right={LARGE_SPACING}
            display="flex"
            justifyContent="flex-end"
          >
            <Typography variant="caption" color="textSecondary" style={{ textAlign: "right", lineHeight: 1 }}>
              {timePeriodLabel}
            </Typography>
          </Box>

          <Box display="flex">
            <RAGCard type="total" animated={!hasAnimationRun} metrics={this.props.metrics} active />

            <RAGCard
              type="green"
              animated={!hasAnimationRun}
              active={this.props.isGreenCardActive}
              metrics={this.props.metrics}
            />

            <RAGCard
              type="amber"
              animated={!hasAnimationRun}
              active={this.props.isAmberCardActive}
              metrics={this.props.metrics}
            />

            <RAGCard
              type="red"
              animated={!hasAnimationRun}
              active={this.props.isRedCardActive}
              metrics={this.props.metrics}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

const mapStateToProps = (state: RootState): ReduxStateProps => {
  // When everything is deselected, all the cards become active
  const isRAGActive = (color: RAGStatus) => {
    const selectedFilters = state.propertyList.selectedStatusFilters;
    return selectedFilters.size === 0 || selectedFilters.has(color);
  };

  return {
    isRedCardActive: isRAGActive("red"),
    isAmberCardActive: isRAGActive("amber"),
    isGreenCardActive: isRAGActive("green"),
    selectedTimePeriod: timePeriodForRecentOnly(
      state.currentUser.user?.toggle_view_tests
    ),
    metrics: state.dashboard.metrics,
  };
};

export default connect(mapStateToProps)(withTranslation()(RAGCards));
